
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemeEnrollmentDialog extends Serenity.EntityDialog<SchemeEnrollmentRow, any> {
        protected getFormKey() { return SchemeEnrollmentForm.formKey; }
        protected getIdProperty() { return SchemeEnrollmentRow.idProperty; }
        protected getLocalTextPrefix() { return SchemeEnrollmentRow.localTextPrefix; }
        protected getService() { return SchemeEnrollmentService.baseUrl; }
        protected getDeletePermission() { return SchemeEnrollmentRow.deletePermission; }
        protected getInsertPermission() { return SchemeEnrollmentRow.insertPermission; }
        protected getUpdatePermission() { return SchemeEnrollmentRow.updatePermission; }
        protected useViewMode() { return true; }
        protected form = new SchemeEnrollmentForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Tenure);
            q.setTextRightAlign(this.form.SchemeAmount);
            q.setTextRightAlign(this.form.BonusValue);
            this.form.SchemeId.changeSelect2(e => {

                
                let tenure;

                SchemeMasterService.Retrieve({
                    EntityId: parseInt(this.form.SchemeId.value)
                }, response => {
                    this.form.Tenure.value  = response.Entity.Tenure
                }, { async: false });


            });


        }

    }
}